import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { HelpdeskTaskPriorityEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk.task.priority.enum';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';
import { HelpdeskTaskPriorityNamePipe } from '@zaoblako/web/shared/pipes/helpdesk-task-priority-name.pipe';

@Component({
  selector: 'crm-priority-multi-select',
  standalone: true,
  imports: [CommonModule, MultiSelectComponent, HelpdeskTaskPriorityNamePipe],
  templateUrl: './priority-multi-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PriorityMultiSelectComponent {
  public priorities: HelpdeskTaskPriorityEnum[] = Object.values(HelpdeskTaskPriorityEnum);

  @Input() public selectedPriorities: HelpdeskTaskPriorityEnum[] = [];
  @Input() public isError = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public disabled: boolean;
  @Input() public appendTo: string;
  @Input() public placeholder = '\u00A0';
  @Input() public showClear = false;

  @Output() public selectedPrioritiesChange = new EventEmitter<HelpdeskTaskPriorityEnum[]>();
}
